import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

const SettingsPerimetersPage = () => import('frontend/pages/settings/SettingsPerimetersPage')
const SettingsPerimetersLayoutPage = () => import('frontend/pages/settings/SettingsPerimetersLayoutPage')

export default [
  {
    path: 'perimeters',
    name: SETTINGS_CARDS_TOKENS.perimeterCreation.name,
    component: SettingsPerimetersPage,
  },
  {
    path: 'layout/:id',
    name: 'settings-perimeter-layout',
    component: SettingsPerimetersLayoutPage,
  },
]
